<template>
  <div>
    <div class="content">
      <b class="">Comment : </b>
      {{this.message}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertCommentBox',
  props: {
    message: {}
  },
  data() {
    return {
    };
  },
  created() {
  }
};
</script>

<style scoped lang="scss">
.content {
  max-width: 64rem;
  margin: 20px auto;
  padding: 20px 33px 19px 20px;
  box-shadow: 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border: solid 2px rgba(255, 255, 255, 0.16);
  background-color: #ebecf0;
    font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6d7587;
  & b {
    font-weight: 600;
  }

}
</style>